<template>
        <el-container id="meter-setting20210423">
                <el-aside width="250px">
                        <div class="aside-box">
                                <div class="aside-title">模板参考对象树</div>
                                <div class="aside-tree">
                                        <el-tree
                                                :data="data"
                                                :props="defaultProps"
                                                accordion
                                                @node-click="treeNodeClick"
                                                
                                              >

                                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                                        <avue-text-ellipsis 
                                                        :text="node.label"
                                                        use-tooltip
                                                        :width="50"
                                                        :height="60"
                                                        
                                                        :is-limit-height="true"
                                                        placement='right-start'
                                                        ></avue-text-ellipsis>
                                                     
                                                       
                                                </span>
                                        </el-tree>
                                </div>


                        </div>
                </el-aside>
                <el-main>
                        <div class="main-box">
                                <div class="main-title">
                                        <el-button @click="addOperator('+')"> + </el-button>
                                        <el-button @click="addOperator('-')"> - </el-button>
                                        <el-button @click="addOperator('*')"> * </el-button>
                                        <el-button @click="addOperator('/')"> / </el-button>
                                        <el-button @click="addOperator('(')"> ( </el-button>
                                        <el-button @click="addOperator(')')"> ) </el-button>
                                        <el-button style="color:#f00;font-size:15px;">公式中请勿加减数字，以免结果出现偏差！</el-button>
                                        <el-button style="float:right;" @click="addOperator('清空')"> 清空 </el-button>
                                        <el-button style="float:right;" @click="lastStep"> 上一步 </el-button>

                                </div>
                                <div class="main-content">
                                        <!-- {{formula}} -->
                                        <textarea
                                                type="textarea"
                                                οnpaste="return false"
                                                class="formula"
                                                style=""
                                                :disabled="disabled"
                                                v-model="formula"
                                                show-word-limit
                                                @click="focusEnd('name-inp-hook')"
                                                id="name-inp-hook"
                                                maxlength="1000"
                                        ></textarea>
                                </div>
                                <div class="main-remark">
                                        <div class="label">
                                                备注
                                        </div>
                                        <el-input
                                        type="textarea"
                                                style="height:100%;"
                                                class="formula"
                                                v-model="remark"
                                                :disabled="disabled"
                                                 show-word-limit
                                                maxlength="500"
                                        ></el-input>
                                </div>
                     
                        </div>
                </el-main>
                <!-- <el-button @click="getData">验证</el-button> -->
        </el-container>
</template>
<script>
  export default {
        props:{
                  
                disabled:{
                        type:Boolean,
                        default:false,
                }
        
        },
    data() {
      return{
              formulaValidation:true,
              temNumber:'',
              value:[],
              remark:'',
              formula:'',
              form:{},
        data: [],
        defaultProps: {
          children: 'children',
          label: 'meterName'
        }
      };
    },
    watch:{
        //    formula 
        'formula'(val,oldval){
               
                if(!this.formulaValidation){
                        this.formulaValidation = true;
                        return;
                }
                
                if(val == oldval){
                        this.formulaValidation = true;
                        return;
                }
                let valLength = val.length;
                let oldvalLength =  oldval.length;
                
                if(valLength < oldvalLength){

                        this.formulaValidation = false;
                        this.formula = oldval;
                        
                }else{
                        
                        if(val.slice(oldvalLength)=='.'){
                                console.log(12312312312123)
                                console.log(this.temNumber.indexOf(val.slice(oldvalLength)))
                                if(this.temNumber.indexOf(val.slice(oldvalLength))>0){
                                        this.formulaValidation = false;
                                        this.formula = oldval;
                                }else{
                                        this.formulaValidation = true;
                                        this.temNumber += '.';
                                        
                                }
                                
                                // this.formula = val;
                                return;
                        }
                         if(val.slice(oldvalLength)==' '){
                                this.formulaValidation = false;
                                this.formula = oldval;
                                return;
                        }
                        let addVal = Number(val.slice(oldvalLength));

                        console.log(addVal);
                        if (!isNaN(addVal)){
                                this.formulaValidation = true;
                                this.temNumber += String(val.slice(oldvalLength));
                                this.formula = val;

                        }else{
                                this.formulaValidation = false;
                                this.formula = oldval;
                                
                        }

                }
                
               
        }
    },
    methods: {
        // setDataTree设置树的数据
        setDataTree(data){
                this.data = data;
        },
        // 使光标始终在末尾
        focusEnd (id) {
        var inpEl = document.getElementById(id)
        inpEl.focus()
        var length = inpEl.value.length
        if (document.selection) {
                var range = inpEl.createTextRange()
                range.moveStart('character', length)
                range.collapse()
                range.select()
        } else if (typeof inpEl.selectionStart === 'number' && typeof inpEl.selectionEnd === 'number') { // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
                inpEl.selectionStart = inpEl.selectionEnd = length
        }
        },
        //     设置默认数据
                setDefaultData(data){
                        console.log(data.formula.length)
                        this.remark= data.remark;
                        for(let i = 0;i<data.formula.length;i++){
                               
                                this.formulaValidation = false;//取消验证
                                
                                if(data.formula[i]=='s'){//还原树的数据
                                // debugger;
                                        this.tagInputNumber();
                                        let length =  this.formula.length;
                                        console.log('data.formulas==>',data.formulas)
                                        let target = data.formulas[0];
                                        let temOBj = {
                                                meterId:target.meterId,
                                                index:length,
                                                value: target.meterName,
                                                valueLenght: target?target.meterName.length:'1',
                                                type:'s',
                                        }

                                        this.value.push(temOBj);
                                        this.formula += data.formulas[0].meterName;
                                        data.formulas.shift();
                                }else if('0123456789.'.indexOf(data.formula[i])>-1){//还原数字

                                        console.log(data.formula[i])
                                        this.temNumber += data.formula[i];  
                                        this.formula += data.formula[i];

                                }else if('()+-*/'.indexOf(data.formula[i])>-1){//还原运算符

                                        console.log(data.formula[i])
                                        this.tagInputNumber();
                                        let length =  this.formula.length;
                                        let temOBj = {
                                                index:length,
                                                value:data.formula[i],
                                                valueLenght:1,
                                                type:'operator',
                                        }
                                        this.value.push(temOBj);
                                        this.formula += data.formula[i];

                                }
                                      
                       
                        }
                        console.log(this.value)
                        console.log(this.temNumber.length)
                        
                        
                },
            omitNumber(e) {
                let value = e;
                value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
                value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
                if (value.indexOf(".") < 0 && value != "") {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                value = parseFloat(value);
                }
                if(value=='.'){
                value = '0.'
                }
                return value;
            },
                // 打包输入数字存入value中，做好标记
                tagInputNumber(){
                        
                        let formulaLength =  this.formula.length;
                        let inputNumberLenght = this.temNumber.length;
                        console.log('inputNumberLenght==>',inputNumberLenght)
                        if(inputNumberLenght<1){//当输入的数字长度为0的时候就不需要做标记了
                                return;
                        }
                        let tagIndex = formulaLength - inputNumberLenght;
                        let temOBj = {
                                index:tagIndex,
                                value:this.temNumber,
                                valueLenght:inputNumberLenght,
                                type:'num',
                        }
                        this.value.push(temOBj);
                        this.temNumber = '';
                },
                getData(callback){
                        this.tagInputNumber();
                        let formula = '';
                        // let formula2 = formula.replace(/s/g,11);
                        let formula2 = '';
                        let energySettingDeptCostMeterList = [];
                        this.value.forEach((ele,index)=>{
                                // formula+=ele.value;
                               

                                if(ele.type=='s'){
                                       formula+='s'; 
                                       formula2 += index*123456;
                                        let temObj = {
                                                meterId:ele.meterId,
                                                sortNum:index
                                        }
                                        energySettingDeptCostMeterList.push(temObj);
                                }else if(ele.type=='operator'){
                                       formula+=ele.value;
                                       formula2+=ele.value; 
                                }else if(ele.type=='num'){

                                       formula+=ele.value; 
                                       formula2+=ele.value; 
                                }
                        })
                        
                        try{
                                console.log(eval(formula2));
                                return{
                                        formula:formula,
                                        meterList:energySettingDeptCostMeterList,
                                        success:true,
                                        remark:this.remark
                                }
                        }catch{
                                return{
                                        formula:formula,
                                        meterList:energySettingDeptCostMeterList,
                                        success:false,
                                        remark:this.remark
                                }
                              
                        }
                        // var r = this.formula.match(/[^+\-*/()]+/g);
                        console.log(formula)
                },
                lastStep(){
                        if(this.disabled){
                                return;
                        }
                        this.formulaValidation = false;
                        let inputNumlength = this.temNumber.length;
                        
                        if(inputNumlength==0){
                                console.log(this.value)
                                if(this.value.length==0){
                                        return;
                                }else{
                                        console.log(123)
                                        let lastValue = this.value[this.value.length-1];
                                        let lastValue2 ='';
                                        console.log(123)
                                        if(this.value.length>1){
                                                lastValue2 = this.value[this.value.length-2];
                                        }
                                        
                                        let formulaLength =  this.formula.length;
                                        console.log(formulaLength)
                                        console.log(lastValue)
                                        this.formula = this.formula.slice(0,formulaLength-lastValue.valueLenght);
                                       
                                        if( this.value.length>1&&lastValue2.type=='num'){
                                                this.temNumber = lastValue2.value;
                                                this.value.pop();
                                                this.value.pop();
                                        }else{
                                                this.value.pop();
                                        }       
                                }

                        }else{
                                let formulaLength =  this.formula.length;
                                this.formula = this.formula.slice(0,formulaLength-inputNumlength);
                                this.temNumber = '';
                                
                        }
                },
                addOperator(operator){
                        if(this.disabled){
                                return;
                        }
                        this.formulaValidation = false;
                        if(operator=='清空'){
                                this.formula = '';
                                this.value = [];
                                this.temNumber = '';
                                return;
                        }
                        this.tagInputNumber();
                        if(operator=='('||operator==')'){
                                let length =  this.formula.length;
                                let temOBj = {
                                        index:length,
                                        value:operator,
                                        valueLenght:1,
                                        type:'operator',
                                }
                                this.value.push(temOBj);
                                this.formula += operator;
                                return;
                        }
                        if(this.value.length==0){
                                return;
                        }
                        let lastValue = this.value[this.value.length-1];
                        let str = '+-*/';
                        if(     lastValue.type=='operator' 
                                &&  str.indexOf(lastValue.value)>-1 
                                && str.indexOf(operator)>-1){ //避免重复添加+-*/
                                this.$message({
                                        message: '请确保计算公式正确',
                                        type: 'warning'
                                });
                                return;
                        }   
                        
                        let length =  this.formula.length;
                        let temOBj = {
                                index:length,
                                value:operator,
                                valueLenght:1,
                                type:'operator',
                        }
                        this.value.push(temOBj);
                        this.formula += operator;
                },
                treeNodeClick(node,key,value){
                       
                        // if(!key.hasChildren){
                                if(this.disabled){
                                        return;
                                }

                                this.tagInputNumber();
                                if(this.value.length==0){
                                        this.formulaValidation = false;
                                        let length =  this.formula.length;
                                        let temOBj = {
                                                meterId:node.id,
                                                index:length,
                                                value:node.meterName,
                                                valueLenght:node.meterName.length,
                                                type:'s',
                                        }
                                        this.value.push(temOBj);
                                        this.formula += node.meterName;
                                        return; 
                                }
                                let lastValue = this.value[this.value.length-1];
                                
                                if(lastValue.type=='s'){ //避免重复添加+-*/
                                        this.$message({
                                                message: '请确保计算公式正确',
                                                type: 'warning'
                                        });
                                        return;
                                } 
                                this.formulaValidation = false;
                                let length =  this.formula.length;
                                let temOBj = {
                                        meterId:node.id,
                                        index:length,
                                        value:node.meterName,
                                        valueLenght:node.meterName.length,
                                        type:'s',
                                }
                                this.value.push(temOBj);
                                this.formula += node.meterName;
                                
                        // }

                },
      handleNodeClick(data) {
        console.log(data);
      },
      renderContent(h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
                <avue-textellipsis text="21213"></avue-textellipsis>
                
          </span>
          );
      }
    }
  };

</script>
<style >
        #meter-setting20210423 .el-textarea__inner{
                height: 100%;
        }
</style>
<style lang="scss" scoped>
        .main-box{
                
                .main-title{
                        // width: 100%;
                        text-align: left;
                        background-color: #eee;
                        padding: 2px 0px;
                        border: 1px solid #3333;
                        flex-grow: 0;
                        flex-shrink: 0;
                }
                .main-content{
                        border: 1px solid #eee;
                        border-bottom: 2px solid #eee;
                        height: 220px;
                        display: flex;
                        overflow: hidden;
                        .formula{
                                height: 100%;
                                // width:100%;
                                flex-shrink:1;
                                flex-grow: 1;
                                border: none;
                        }
                        // width: 100%;
                }
                .main-remark{
                        display: flex;
                        margin-top: 20px;
                        height: 118px;
                        .label{
                                width: 50px;
                                margin-right: 10px;
                                // font-size: 18px;
                                // font-weight: 600;
                                color: #333;
                        }

                }
        }
        .el-aside {
                // background-color: #D3DCE6;
                color: #333;
                /* text-align: center; */
                /* line-height: 200px; */
              
                height: 400px;
                // padding: 0 10px;
                .aside-box{
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        // justify-content: space-between;
                        .aside-title{
                                background-color: #eee;
                                padding: 2px 10px;
                                border: 1px solid #3333;
                                flex-grow: 0;
                                flex-shrink: 0;
                        }
                        .aside-tree{
                                flex-grow: 1;
                                flex-shrink: 1;
                                overflow: hidden;
                                overflow-y: auto;
                                overflow-x: auto;
                                border: 1px solid #3333;
                        }
                }
        }
  
        .el-main {
                margin-left: 10px;
                // background-color: #E9EEF3;
                color: #333;
                text-align: center;
                .main-box{
                        height: 100%;
                        
                }
        }
</style>

